import Skeleton, { SkeletonProps } from 'react-loading-skeleton';

export function SkeletonLoader({ className, ...props }: SkeletonProps) {
  const resolvedClassName = className ? `skeleton ${className}` : 'skeleton';
  return <Skeleton className={resolvedClassName} {...props} />;
}
